import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import GisApiServices from "../../services/GisApiServices";
import { useNavigate } from "react-router-dom";
function DataManagement() {
  const [activeTab, setActiveTab] = useState("tab1");
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });
  const switchDivRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { isTheme } = useSelector((state) => state.currentStage)
  const authData = useSelector(state => state.authToken.authData);
  const [isGetPermission, setIsGetPermission] = useState([]);
  const tabs = [
    // {
    //   id: "tab1",
    //   label: "Data Import",
    //   content: <DataImport />,
    //   activeImage: isTheme === 'light' ? "img/data-light.svg" : "img/activeimportdata.svg",
    //   inactiveImage: isTheme === 'light' ? "img/data-de-light.svg" : "img/deactiveimportdata.svg",
    //   activityId: 'D1'
    // },
    {
      id: "tab2",
      label: "Data Catalog",
      content: <DataCataLog />,
      activeImage: isTheme === 'light' ? "img/catalog-light.svg" : "img/activedatalog.svg",
      inactiveImage: isTheme === 'light' ? "img/catalog-de-light.svg" : "img/deactivedatalog.svg",
      activityId: 'D2'
    },
    // {
    //   id: "tab3",
    //   label: "Data Backup & Recovery",
    //   content: <DataBackup />,
    //   activeImage: isTheme === 'light' ? "img/recent-light.svg" : "img/activebackup.svg",
    //   inactiveImage: isTheme === 'light' ? "img/recent-de-light.svg" : "img/recentdeactive.svg",
    //   activityId: 'D3'
    // },
  ];

  const fetchUserPermission = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const value = {
        role_Id: authData?.RoleID
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const response = await GisApiServices.userPermissions(value, config);
      const getPermission = response.data?.data || [];
      setIsGetPermission(getPermission?.permissions)
    } catch (error) {
      console.error("Error fetching user roles", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchUserPermission()
  }, [])

  useEffect(() => {
    dispatch(setIsWidth(false))
    dispatch(currentStageData(''))
    const updateSlider = () => {
      const activeElement = switchDivRef.current.querySelector(".active-tab-act");
      if (activeElement) {
        const { offsetLeft: left, offsetWidth: width } = activeElement;
        setSliderStyle({ left, width });
      }
    };

    updateSlider();
    window.addEventListener("resize", updateSlider);

    return () => {
      window.removeEventListener("resize", updateSlider);
    };
  }, [activeTab]);

  const filteredTabs = tabs.filter(tab =>
    isGetPermission.some(permission => permission.activityId === tab.activityId)
  );

  return (
    <>
      {/* <div className="filterdiv">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-12">
            <div className="fildiv" style={{ gap: "12px" }}>
              <div className="search-container1">
                <input
                  className="access-search"
                  placeholder="Search activity"
                />
                <span className="search-img">
                  {isTheme === "light" ? <img src="img/bluesearch.svg" alt='search' /> :
                    <img src="img/Vectorsearch.png" alt='search' />}
                </span>
              </div>
              <button className="filter-btn">Filter</button>
              <button className="filter-btn">Sort</button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="switch-tabs">
        {/* Tab Buttons */}
        <div className="switchdivact" ref={switchDivRef}>
          {filteredTabs.map((tab) => (
            <div
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn-access-switch ${activeTab === tab.id ? "active-tab-act" : ""}`}
            >
              <img
                src={activeTab === tab.id ? tab.activeImage : tab.inactiveImage}
                alt={tab.label}
                className="tab-icon"
              />
              <span>{tab.label}</span>
            </div>
          ))}
          <div
            className="acitveslider"
            style={{ ...sliderStyle, transition: "all 0.3s ease" }}
          ></div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {filteredTabs.map(
            (tab) =>
              activeTab === tab.id && (
                <div key={tab.id} className="tab-panel">
                  {tab.content}
                </div>
              )
          )}
        </div>
      </div>

    </>
  )
}

const DataImport = () => {
  return (
    <>
      <div className="dataimportdiv">
        <h6 className="tab-text">Adding new datasets to the system or exporting existing data.</h6>

      </div>
    </>
  )
}

const DataCataLog = () => {
  return (
    <>
      {/* <h6 className="tab-text">Data CataLog</h6> */}
    </>
  )
}

const DataBackup = () => {
  const { isTheme } = useSelector((state) => state.currentStage)
  return (
    <div className="apimanagemenentdiv">
      <div className="row">
        <div className="col-xl-10 col-lg-11 col-md-12">
          <div className="backupdiv">
            <div>
              <h5 className="backupdiv-title">Backup available</h5>
              <h6>56 Datasets available for backup</h6>
            </div>
            <div>
              <button className="role-active px-5">Backup Now</button>
            </div>
          </div>
          <div className="mt-3">
            <h6 className="backupdiv-title">Previous Backups</h6>
            <div className="table-responsive mt-3">
              <table className="table table-dark-security caption-top manage-user-table">
                <thead>
                  <tr>
                    <th scope="col" className="text-start">Backup serial</th>
                    <th scope="col">Uploaded date</th>
                    <th scope="col">Quick actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-start">
                      Backup_13_Nov_2024_19:11
                    </td>
                    <td>13 Nov 2024 , 07:11 PM</td>
                    <td >
                      <div className='checkboxsetting justify-content-center'>
                        <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                          {isTheme === "light" ? <img src="img/pencil-light.svg" alt='pencil' /> :
                            <img src="img/pencil.svg" alt='pencil' />
                          }
                        </div>
                        <div type="button">
                          {isTheme === "light" ? <img src="img/trash-bin-light.svg" alt='pencil' /> :
                            <img src="img/trashbin.svg" alt='delete' />
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      Backup_12_Nov_2024_17:57
                    </td>
                    <td>13 Nov 2024 , 05:57 PM</td>
                    <td >
                      <div className='checkboxsetting justify-content-center'>
                        <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                          {isTheme === "light" ? <img src="img/pencil-light.svg" alt='pencil' /> :
                            <img src="img/pencil.svg" alt='pencil' />
                          }
                        </div>
                        <div type="button">
                          {isTheme === "light" ? <img src="img/trash-bin-light.svg" alt='pencil' /> :
                            <img src="img/trashbin.svg" alt='delete' />
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataManagement